import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeTrackingService } from '../api/time-tracking.service';
import { TIME_TRACKING_KEYS } from './queryKeys';

export function useActiveTimer() {
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useQuery({
    queryKey: TIME_TRACKING_KEYS.activeTimer(activeOrganizationId ?? ''),
    queryFn: ({ signal }) => timeTrackingService.getActiveTimer(signal),
    staleTime: 0,
    refetchInterval: 30_000,
    enabled: !!activeOrganizationId,
  });
}
